/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whole-range totals for the billing usage details
 */
export type TumDetailsTotals = {
  /**
   * Observed cache-write tokens — prompt content entering the provider cache, counted once
   */
  cacheCreationTokens: number;
  /**
   * Observed input tokens (cache reads excluded)
   */
  inputTokens: number;
  /**
   * Observed output tokens
   */
  outputTokens: number;
  /**
   * Tokens under management: input + output + cache writes
   */
  totalTokens: number;
};

/** @internal */
export const TumDetailsTotals$inboundSchema: z.ZodMiniType<
  TumDetailsTotals,
  unknown
> = z.pipe(
  z.object({
    cache_creation_tokens: z.int(),
    input_tokens: z.int(),
    output_tokens: z.int(),
    total_tokens: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cache_creation_tokens": "cacheCreationTokens",
      "input_tokens": "inputTokens",
      "output_tokens": "outputTokens",
      "total_tokens": "totalTokens",
    });
  }),
);

export function tumDetailsTotalsFromJSON(
  jsonString: string,
): SafeParseResult<TumDetailsTotals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TumDetailsTotals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TumDetailsTotals' from JSON`,
  );
}
